// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    {{#if isCashAvailable && !noArrowCB}}
    <terceraComboBox
        items="{{qtyCashItems}}"
        selectedItem="{{qtyCashSelectedItem}}"
        showLastValue="true"
        tooltip="{{qtyCashTooltip}}"
        elementStyle="quantity-combobox"
    />
    {{/if}} {{#if showLabel && (!isCashAvailable || noArrowCB)}}
    <terceraLabel
        additionalClass="{{#positionSizingChecked}}js-quantity-numeric-label-position-sizing-checked{{/}} "
        visible="{{.visible}}"
        text="{{label}}"
    />
    {{/if}}
    <div class="underlabel-container">
        <div class="oe-selector-right">
            {{#if positionSizingVisible && !isCashMode}}
            <PositionSizeButton
                visible="{{positionSizingVisible && !isCashMode}}"
                instrument="{{instrument}}"
                account="{{account}}"
                checked="{{positionSizingChecked}}"
            />
            {{/if}}

            <terceraQuantityNumeric
                customCSSClass="{{customCSSClass}}"
                account="{{account}}"
                instrument="{{instrument}}"
                value="{{value}}"
                inLots="{{inLots}}"
                defaultQuantity="{{defaultQuantity}}"
                visible="{{.visible}}"
                enabled="{{.enabled}}"
                minValue="{{.minValue}}"
                maxValue="{{.maxValue}}"
                noArrowCB="{{.noArrowCB}}"
                tooltip="{{.tooltip}}"
                validationStateInfo="{{validationStateInfo}}"
                valueLessMinLocalKey="{{.valueLessMinLocalKey}}"
                valueGreaterMaxLocalKey="{{.valueGreaterMaxLocalKey}}"
                assetNameForCash="{{assetNameForCash}}"
                name="QN"
            />
        </div>

        {{#isCashMode}}
        <div class="underlabel">
            <terceraLabel text="{{estQtyFormatted}}" />
        </div>
        {{/}}
    </div>
</div>
`;
// Exports
export default code;